import type { NextPage } from "next";
import Header from "./Common/header";
import Footer from "./Common/footer";
import { PropsWithChildren } from "react";

// interface Props {
//   children: JSX;
// }

const Layout: NextPage = (props) => {
  const { children } = props;
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
